import { Heading, Span } from "@icg360/design-system";

import styles from "./roof-marketplace-drawer.module.scss";

/**
 * Grey box card in the Roof marketplace drawer that introduces the
 * RoofMarketplace partnership (logo, headline, body copy).
 * Uses design tokens: background/low-emphasis, border/default, Spacing/xl, Spacing/md, text/default.
 */
export const PartnershipCard = () => (
  <div className={styles.partnershipCard}>
    <img
      src="/assets/images/roof-marketplace.svg"
      alt="Roof Marketplace"
      className={styles.partnershipCardLogo}
      width={191}
      height={60}
    />
    <Heading size="xs" className={styles.partnershipCardHeadline}>
      Trusted roofing help is a click away
    </Heading>
    <Span className={styles.partnershipCardBody}>
      {`Your roof is your home's first line of defense - it will help protect your family, your belongings, and your biggest investment for years to come. SageSure provides access to RoofMarketplace, so you can get competitive bids from vetted contractors who meet high workmanship standards.`}
    </Span>
  </div>
);
